

import React from 'react';
import { useLocation } from 'react-router-dom';

const PageTitle = () => {
    const location = useLocation();

    // Determine the page title based on the current route
    const getPageTitle = (pathname) => {
        switch (pathname) {
            case '/':
                return 'home';
            case '/profile':
                return 'profile';
            case '/resume':
                return 'resume';
            case '/portfolio':
                return 'portfolio';
            case '/certifications':
                return 'certifications';
            default:
                return 'Page Not Found';
        }
    };

    const pageTitle = getPageTitle(location.pathname);

    return (
        <header className="header-section text-start py-3">
            <span className="text-accent">/{pageTitle}</span>
        </header>
    );
};

export default PageTitle;
